import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PatientLoader from "../../../common/PatientLoader";
import AllClinicsDataTable from "./AllClinicsDataTable";
import {
  fetchHealthCareGroupsLogic,
  fetchTestHealthCareGroupsLogic,
  searchClinicsLogic,
} from "../../../../store/features/ops/opsSlice";
import SidebarLayout from "../../../common/sidebar/SidebarLayout";
import { Helmet } from "../../../common/Helmet";
import { ReactComponent as DownloadIcon } from "../../../../assets/icons/TestAccounts.svg";
import OPSPrimaryHeader from "../../../common/primaryHeader/OPSPrimaryHeader";
import { useParams } from "react-router-dom";

const AllClinics = () => {
  const dispatch = useDispatch();
  const { opsLoading, allClinics } = useSelector((state) => state.ops);
  const [testOnly, setTestOnly] = useState(params?.type);
  const [testClinics, setTestClincs] = useState([]);
  const [loading, setLoading] = useState(true);
  const params = useParams();
  useEffect(() => {
    if (params?.type === "test") {
      setTestOnly(true);
    } else {
      setTestOnly(false);
    }
  }, [params]);
  useEffect(() => {
    dispatch(fetchHealthCareGroupsLogic({ is_test_account: 0, search: "" }));
    dispatch(searchClinicsLogic({ search: "" }));
    fetchTestHealthCareGroupsLogic({ is_test_account: 1, search: "" })
      .then((res) => {
        setTestClincs(res.data);
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
      });
  }, []);
  return (
    <SidebarLayout>
      <section className="contianer-fluid px-5 py-2">
        <Helmet>
          <meta charSet="utf-8" />
          <title>{testOnly ? "Test" : "All"} Clinics | Precise Digital</title>
          <link rel="canonical" href={window.location.origin} />
        </Helmet>
        <div
          className="container-fluid px-3 d-flex justify-content-between"
          style={{ alignContent: "center", alignItems: "center" }}
        >
          <OPSPrimaryHeader
            titleText={`${testOnly ? "Test" : "All"} Healthcare Groups`}
            showSubtitle={false}
            showButton={false}
            showPill={true}
            pillText={`${
              testOnly ? testClinics?.length : allClinics?.length || 0
            } Groups`}
          />
          <button className="primary-btn d-flex" style={{ gap: "10px" }}>
            <DownloadIcon /> Download
          </button>
        </div>
        {opsLoading || loading ? <PatientLoader /> : <AllClinicsDataTable />}
      </section>
    </SidebarLayout>
  );
};

export default AllClinics;
